// extracted by mini-css-extract-plugin
export default {"container":"home_container__EGMTD","box":"home_box__R0+cA","boxContain":"home_boxContain__bxu4N","form":"home_form__nVJ0i","footer":"home_footer__Ksn+a"};